module.exports = __webpack_public_path__ + "static/media/RoundedRect_Grey@2x.a26e66cb.png";